import { render, staticRenderFns } from "./VwTapGrid.vue?vue&type=template&id=406fe454&"
import script from "./VwTapGrid.vue?vue&type=script&lang=js&"
export * from "./VwTapGrid.vue?vue&type=script&lang=js&"
import style0 from "./VwTapGrid.vue?vue&type=style&index=0&id=406fe454&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports